/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import i18n from 'i18next';
import { components } from 'react-select';

import { Typo } from 'uikit/content';

import styles from '../styles/selectOptionWithCode.module.scss';

const SelectOptionWithCode = (props) => {
  const {
    value: { name, code },
  } = props;

  return (
    <components.Option {...props}>
      <div className={styles.element}>
        <Typo element="span" title={name} variant="s02">
          {name}
        </Typo>
        <div className={styles.meta}>
          {code && (
            <Typo color="secondary" element="span" title={code} variant="s01">
              {`${i18n.t('code')}: ${code}`}
            </Typo>
          )}
        </div>
      </div>
    </components.Option>
  );
};

export default SelectOptionWithCode;
